import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {selectAllPropPresets} from "../../app/slices/TrainingSlice";
import PropCard from "./PropCard";
import {matchesPresetSearch} from "../editor_columns/PresetColumnHeader";

export default function PropPresetList({search = ""}: {search?: string}) {
    const allProps = useSelector(selectAllPropPresets);
    const {t} = useTranslation();

    const visibleProps = allProps.filter((prop) => matchesPresetSearch(prop.name, search));

    const allPropsMapped = visibleProps.map((prop) => {
        return <PropCard key={prop.id} prop={prop} />
    });

    // Same compact list as the actors column.
    return <div data-testid="prop-list" className={"w-full h-full px-[8px] pt-[4px] pb-[4px] flex flex-col gap-y-[2px] overflow-y-auto pit-creator-scrollbar"}>
        {allPropsMapped}
        {visibleProps.length === 0 && allProps.length > 0 && (
            <div className="px-[8px] py-[8px] text-[13px] italic text-creator-text-sub" data-testid="prop-list-no-matches">
                {t("preset_lists.no_matches")}
            </div>
        )}
    </div>
}
